import React from 'react';

import { useParams } from "react-router-dom";

import './Login.css';
import Hosts from '../../Hosts'

import {

	repo_logo_link,
	repo_img_link,

} from '../../Utils';


// or
//import { Tabs } from '@material-ui/core';
import RecuperarForm from "./RecuperarForm";

const Recuperar = ({ hash, type }) => {

  return (
    <div id="login">
      <div className="login-wrapper" style={{
        backgroundImage: `url(` + repo_img_link("concrete_seamless.png") + `)`,
        backgroundRepeat: 'repeat',
        backgroundPosition: 'top center',
        backgroundAttachment: 'fixed',
        backgroundColor: '#f7f7f7'
      }}>
        <div className="div-right" style={(type === 'access' ? { maxWidth: '550px' } : '')}>
          <div className='div-login-form'>
            <div className="form-header">
              <a href={Hosts.WEB_SITE_URI} rel="noreferrer" target="_blank">
                <img alt='' src={repo_logo_link("logo.svg")}  style={{width: '180px'}} />      
              </a>      
            </div>

            <div className="div-form">            
              <RecuperarForm hash={hash} type={type} loginType='/entities/password/recovery' />            
            </div>
            <div className="form-footer">

            </div>
          </div>
        </div>
      </div>
    </div>

  );

}

export default Recuperar;

